// const API_BASE_URL = 'http://64.227.145.76/city-flower-backend-master/public'
// const API_STORAGE_URL = 'http://64.227.145.76/city-flower-backend-master/public'
const API_BASE_URL = 'https://api.cityflowerksa.com'
const API_STORAGE_URL = 'https://api.cityflowerksa.com'
const NAME = 'City Flower'
const GOOGLE_API_TOKEN = ''
export default {
	API_BASE_URL, NAME, GOOGLE_API_TOKEN, API_STORAGE_URL,
}
